import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [billing, setBilling] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const refreshBilling = useCallback(async () => {
    try {
      const { data } = await api.get("/billing/me");
      setBilling(data);
      return data;
    } catch {
      setBilling(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (user?.role) refreshBilling();
    else setBilling(null);
  }, [user?.user_id, user?.role, refreshBilling]);

  const signIn = (token, u) => {
    setToken(token);
    setUser(u);
    setLoading(false);
  };

  const signOut = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setToken(null);
    setUser(null);
    setBilling(null);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, loading, refresh, signIn, signOut, billing, refreshBilling }}>{children}</AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
